const javaCodeBrowserStack = `public static final String AUTOMATE_USERNAME = "<Your_User_Name>";
public static final String AUTOMATE_ACCESS_KEY = "<Your_Access_key>";
public static final String URL = "https://" + AUTOMATE_USERNAME + ":" + AUTOMATE_ACCESS_KEY + "@hub-cloud.browserstack.com/wd/hub";
public static void main(String[] args) throws Exception {
    BS_MIGRATION_TEST_CAPABILITY
    caps.setCapability("name", "BStack-[Java] Sample Test"); // test name
    caps.setCapability("build", "BStack Build Number 1"); // CI/CD job or build name
    WebDriver driver = new RemoteWebDriver(new URL(URL), caps);
}`;

const javaCodeLambdatest = `public String username = "UserName";
public String accesskey = "AccessKey";
public String gridURL = "@${process.env.REACT_APP_HUB_URL}";
LT_MIGRATION_TEST_CAPABILITY
`;

const javaCodeSoucelab = `public static final String user_name = "<Your_Username>";
public static final String access_key = "<Your_Access_key>";
public static final String Hub_URL = "https://" + user_name + ":" + access_key + "@ondemand.us-west-1.saucelabs.com:443/wd/hub";
SL_MIGRATION_TEST_CAPABILITY`;

const javascriptCodelambdatest = `const USERNAME = "UserName";
// Accesskey:  Accesskey can be generated from automation dashboard or profile section
const KEY = 'AccessKey';
// gridUrl: gridUrl can be found at automation dashboard
const GRID_HOST = '${process.env.REACT_APP_HUB_URL}';
LT_MIGRATION_TEST_CAPABILITY
`;

const javascriptCodeBrowserstack = `BS_MIGRATION_TEST_CAPABILITY
   
// Changes in the Config
let driver = new webdriver.Builder()
    .usingServer('https://<Your_User_Name>:<Your_Access_key>@hub-cloud.browserstack.com/wd/hub')
    .withCapabilities(capabilities)
    .build();
    `;

const javascriptCodeSoucelab = `const user_name = "<Your_Username>";
const access_key = "<Your_Access_key>";
const Hub_URL = "https://" + user_name + ":" + access_key + "@ondemand.us-west-1.saucelabs.com:443/wd/hub";
SL_MIGRATION_TEST_CAPABILITY`;

const pythonCodeBrowserstack = `BS_MIGRATION_TEST_CAPABILITY
driver = webdriver.Remote(
    command_executor='https://<Your_User_Name>:<Your_Access_Key>@hub-cloud.browserstack.com/wd/hub',
    desired_capabilities=desired_cap)
    `;

const pythonCodeSoucelab = `user_name = "<Your_Username>";
access_key = "<Your_Access_key>";
Hub_URL = "https://" + user_name + ":" + access_key + "@ondemand.us-west-1.saucelabs.com:443/wd/hub";
SL_MIGRATION_TEST_CAPABILITY`;

const pythonCodeLambdatest = `username = "UserName"
access_key = "AccessKey"
grid_host = '${process.env.REACT_APP_HUB_URL}'
LT_MIGRATION_TEST_CAPABILITY
`;

const rubyCodeLambdatest = `USERNAME = "UserName"
ACCESS_KEY = 'AccessKey'
GRID_HOST = '${process.env.REACT_APP_HUB_URL}'
LT_MIGRATION_TEST_CAPABILITY
`;
const rubyCodeBrowserstack = `BS_MIGRATION_TEST_CAPABILITY
driver = Selenium::WebDriver.for(:remote,
  :url => "https://<Your_User_Name>:<Your_Access_key>@hub-cloud.browserstack.com/wd/hub",
  :desired_capabilities => caps)`;

const rubyCodeSoucelab = `user_name = "<Your_Username>";
access_key = "<Your_Access_key>";
Hub_URL = "https://" + user_name + ":" + access_key + "@ondemand.us-west-1.saucelabs.com:443/wd/hub";
SL_MIGRATION_TEST_CAPABILITY`;

const credentialsCodeLinux = `export LT_USERNAME = UserName
export LT_Access_Key = AccessKey`;
const credentialsCodeWindows = `set LT_USERNAME = UserName
set LT_Access_Key = AccessKey`;

const robotVirtualEnvSetupLinux = `virtualenv venv\nsource venv/bin/activate`;
const robotVirtualEnvSetupWindows = `python -m virtualenv venv\nvenv\Scripts\activate.bat`;
const lettuceEnvSetupLinux = `virtualenv venv\nsource venv/bin/activate`;
const lettuceEnvSetupWindows = `python -m virtualenv venv\nvenv\Scripts\activate.bat`;

const phpCodeLambdatest = `LT_MIGRATION_TEST_CAPABILITY`;

const phpCodeBrowserStack = `BS_MIGRATION_TEST_CAPABILITY`;

const phpCodeSoucelab = `SL_MIGRATION_TEST_CAPABILITY`;

const csharpCodeBrowserstack = `BS_MIGRATION_TEST_CAPABILITY`;
const csharpCodeSoucelab = `SL_MIGRATION_TEST_CAPABILITY`;

const csharpCodeLambdatest = `LT_MIGRATION_TEST_CAPABILITY`;

const javaCredentialCodeLT = `public String username = "UserName";
public String accesskey = "AccessKey";`;
const javaCredentialCodeBS = `public static final String AUTOMATE_USERNAME = "<Your_User_Name>";
public static final String AUTOMATE_ACCESS_KEY = "<Your_Access_key>";`;
const javaCredentialCodeSL = `public static final String user_name = "<Your_Username>";
public static final String access_key = "<Your_Access_key>";`;

const javaHubUrlCodeLT = `public String gridURL = "https://UserName:AccessKey@${process.env.REACT_APP_HUB_URL}"`;
const javaHubUrlCodeBS = `public static final String URL = "https://<Your_User_Name>:<Your_Access_key>@hub-cloud.browserstack.com/wd/hub"`;
const javaHubUrlCodeSL = `public static final String Hub_URL = "https://<Your_Username>:<Your_Access_key>@ondemand.us-west-1.saucelabs.com:443/wd/hub"`;

const nodeCredentialCodeLT = `const USERNAME = "UserName";
const KEY = "AccessKey";`;
const nodeCredentialCodeBS = `const AUTOMATE_USERNAME = "<Your_User_Name>";
const AUTOMATE_ACCESS_KEY = "<Your_Access_key>";`;
const nodeCredentialCodeSL = `const user_name = "<Your_Username>";
const access_key = "<Your_Access_key>";`;

const nodeHubUrlCodeLT = `const GRID_HOST = "https://UserName:AccessKey@${process.env.REACT_APP_HUB_URL}";`;
const nodeHubUrlCodeBS = `cont URL = "https://<Your_User_Name>:<Your_Access_key>@hub-cloud.browserstack.com/wd/hub"`;
const nodeHubUrlCodeSL = `const Hub_URL = "https://<Your_Username>:<Your_Access_key>@ondemand.us-west-1.saucelabs.com:443/wd/hub";`;

const pythonCredentialCodeLT = `username = "UserName"
access_key = "AccessKey"`;
const pythonCredentialCodeBS = `AUTOMATE_USERNAME = "<Your_User_Name>";
AUTOMATE_ACCESS_KEY = "<Your_Access_key>";`;
const pythonCredentialCodeSL = `user_name = "<Your_Username>";
access_key = "<Your_Access_key>";`;

const pythonHubUrlCodeLT = `grid_host = "https://UserName:AccessKey@${process.env.REACT_APP_HUB_URL}"`;
const pythonHubUrlCodeBS = `URL = "https://<Your_User_Name>:<Your_Access_key>@hub-cloud.browserstack.com/wd/hub"`;
const pythonHubUrlCodeSL = `Hub_URL = "https://<Your_Username>:<Your_Access_key>@ondemand.us-west-1.saucelabs.com:443/wd/hub";`;

const rubyCredentialCodeLT = `USERNAME = "UserName"
ACCESS_KEY = 'AccessKey'`;
const rubyCredentialCodeBS = `AUTOMATE_USERNAME = "<Your_User_Name>";
AUTOMATE_ACCESS_KEY = "<Your_Access_key>";`;
const rubyCredentialCodeSL = `user_name = "<Your_Username>";
access_key = "<Your_Access_key>";`;

const rubyHubUrlCodeLT = `GRID_HOST = "https://UserName:AccessKey@${process.env.REACT_APP_HUB_URL}"`;
const rubyHubUrlCodeBS = `URL = "https://<Your_User_Name>:<Your_Access_key>@hub-cloud.browserstack.com/wd/hub"`;
const rubyHubUrlCodeSL = `Hub_URL = "https://<Your_Username>:<Your_Access_key>@ondemand.us-west-1.saucelabs.com:443/wd/hub";`;

const phpCredentialCodeLT = `username = "UserName"
access_key = "AccessKey"`;
const phpCredentialCodeBS = `AUTOMATE_USERNAME = "<Your_User_Name>";
AUTOMATE_ACCESS_KEY = "<Your_Access_key>";`;
const phpCredentialCodeSL = `user_name = "<Your_Username>";
access_key = "<Your_Access_key>";`;

const phpHubUrlCodeLT = `grid_host = "https://UserName:AccessKey@${process.env.REACT_APP_HUB_URL}"`;
const phpHubUrlCodeBS = `URL = "https://<Your_User_Name>:<Your_Access_key>@hub-cloud.browserstack.com/wd/hub"`;
const phpHubUrlCodeSL = `Hub_URL = "https://<Your_Username>:<Your_Access_key>@ondemand.us-west-1.saucelabs.com:443/wd/hub";`;

const csharpCredentialCodeLT = `string username = "UserName"
string access_key = "AccessKey"`;
const csharpCredentialCodeBS = `string AUTOMATE_USERNAME = "<Your_User_Name>";
string AUTOMATE_ACCESS_KEY = "<Your_Access_key>";`;
const csharpCredentialCodeSL = `string user_name = "<Your_Username>";
string access_key = "<Your_Access_key>";`;

const csharpHubUrlCodeLT = `string grid_host = "https://UserName:AccessKey@${process.env.REACT_APP_HUB_URL}"`;
const csharpHubUrlCodeBS = `string URL = "https://<Your_User_Name>:<Your_Access_key>@hub-cloud.browserstack.com/wd/hub"`;
const csharpHubUrlCodeSL = `string Hub_URL = "https://<Your_Username>:<Your_Access_key>@ondemand.us-west-1.saucelabs.com:443/wd/hub";`;

export {
  javaCodeBrowserStack,
  javaCodeLambdatest,
  javaCodeSoucelab,
  javascriptCodelambdatest,
  javascriptCodeBrowserstack,
  javascriptCodeSoucelab,
  rubyCodeLambdatest,
  rubyCodeBrowserstack,
  rubyCodeSoucelab,
  pythonCodeBrowserstack,
  pythonCodeSoucelab,
  pythonCodeLambdatest,
  credentialsCodeWindows,
  credentialsCodeLinux,
  robotVirtualEnvSetupLinux,
  robotVirtualEnvSetupWindows,
  lettuceEnvSetupLinux,
  lettuceEnvSetupWindows,
  phpCodeBrowserStack,
  phpCodeSoucelab,
  phpCodeLambdatest,
  csharpCodeBrowserstack,
  csharpCodeSoucelab,
  csharpCodeLambdatest,
  javaCredentialCodeLT,
  javaCredentialCodeBS,
  javaCredentialCodeSL,
  javaHubUrlCodeLT,
  javaHubUrlCodeBS,
  javaHubUrlCodeSL,
  nodeCredentialCodeLT,
  nodeCredentialCodeBS,
  nodeCredentialCodeSL,
  nodeHubUrlCodeLT,
  nodeHubUrlCodeBS,
  nodeHubUrlCodeSL,
  pythonCredentialCodeLT,
  pythonCredentialCodeBS,
  pythonCredentialCodeSL,
  pythonHubUrlCodeLT,
  pythonHubUrlCodeBS,
  pythonHubUrlCodeSL,
  rubyCredentialCodeLT,
  rubyCredentialCodeBS,
  rubyCredentialCodeSL,
  rubyHubUrlCodeLT,
  rubyHubUrlCodeBS,
  rubyHubUrlCodeSL,
  phpCredentialCodeLT,
  phpCredentialCodeBS,
  phpCredentialCodeSL,
  phpHubUrlCodeLT,
  phpHubUrlCodeBS,
  phpHubUrlCodeSL,
  csharpCredentialCodeLT,
  csharpCredentialCodeBS,
  csharpCredentialCodeSL,
  csharpHubUrlCodeLT,
  csharpHubUrlCodeBS,
  csharpHubUrlCodeSL
};
